import { Button } from 'avo-ui'
import { PrintLabelModal } from 'components/order/request-awb/PrintLabelModal'

export const RightButton = ({
    query,
    isSelectAWBError,
    onClickRightButton,
    selectedValue,
    isLoadingPreview,
    modal,
    onHide,
    printLabelHandler,
    isLoadingBulkPrintLabel,
    previewDetail,
}) => {
    return (
        <div className={'flex gap-x-4'}>
            {query?.tab === 'request awb' && (
                <Button
                    title={'Pindah ke Label'}
                    disabled={!isSelectAWBError()}
                    onClick={() =>
                        onClickRightButton('move-to-print-label', 'Are You Sure to Move Order to Print Label ?')
                    }
                />
            )}
            <Button
                title={query?.tab === 'request awb' ? 'Request AWB' : 'Print Label'}
                disabled={selectedValue?.selectedIds?.length === 0}
                loading={isLoadingPreview}
                onClick={() => onClickRightButton('request-awb', 'Are You Sure to Request AWB ?')}
            />
            <PrintLabelModal
                show={modal?.printLabel}
                onHide={onHide}
                printLabelHandler={printLabelHandler}
                isLoading={isLoadingBulkPrintLabel}
                list={previewDetail}
            />
        </div>
    )
}
